import { MEDIA_SETTINGS_STORAGE_KEY, SETTINGS_STORAGE_KEY } from "../utils/constants";
import UserMediaService from "./UserMediaService";

export interface StoredMediaSettings {
  userName: string;
  isMicEnabled: boolean;
  isCameraEnabled: boolean;
  selectedMicId: string;
  selectedCameraId: string;
}

export const getDefaultMediaSettings = () => {
  return {
    userName: '',
    isMicEnabled: true,
    isCameraEnabled: true,
    selectedMicId: UserMediaService.audioInputDeviceId,
    selectedCameraId: UserMediaService.videoInputDeviceId,
  }
};

export function getStoredOrDefaultMediaSettings() {
  const storedSettings = getStoredMediaSettings();
  const defaultMediaSettings = getDefaultMediaSettings();
  if (!storedSettings) return defaultMediaSettings;
  const storedMediaSettings: StoredMediaSettings = {
    userName: storedSettings?.userName ?? defaultMediaSettings.userName,
    isMicEnabled: storedSettings?.isMicEnabled ?? defaultMediaSettings.isMicEnabled,
    isCameraEnabled: storedSettings?.isCameraEnabled ?? defaultMediaSettings.isCameraEnabled,
    selectedMicId: storedSettings?.selectedMicId ?? defaultMediaSettings.selectedMicId,
    selectedCameraId: storedSettings?.selectedCameraId ?? defaultMediaSettings.selectedCameraId,
  }
  return storedMediaSettings;
}

export function getStoredMediaSettings() {
  const storageItem = localStorage.getItem(MEDIA_SETTINGS_STORAGE_KEY);
  if (!storageItem) return;
  const storedSettings = JSON.parse(storageItem);
  if (!storedSettings) return;
  const storedMediaSettings: Partial<StoredMediaSettings> = Object.fromEntries(
    Object.entries(storedSettings).filter(([_, value]) => value !== undefined)
  );
  return storedMediaSettings;
}

export function getIsSelfViewEnabled() {
  const storageItem = localStorage.getItem(SETTINGS_STORAGE_KEY);
  if (!storageItem) return false;
  const storedSettings = JSON.parse(storageItem);
  return storedSettings && storedSettings.showSelfView === true;
}

export function getIsSlowSettingEnabled() {
  const storageItem = localStorage.getItem(SETTINGS_STORAGE_KEY);
  if (!storageItem) return false;
  const storedSettings = JSON.parse(storageItem);
  return storedSettings && storedSettings.slowSystem === true;
}

export function getIsDebugEnabled() {
  const storageItem = localStorage.getItem(SETTINGS_STORAGE_KEY);
  if (!storageItem) return false;
  const storedSettings = JSON.parse(storageItem);
  return storedSettings && storedSettings.debug === true;
}
